import React from "react";
import camelToTitleCase from "../../camelToTitleCase";
import OutputFactory from "../OutputFactory";
// import OutputFactory from "../OutputFactory";

const DEFAULT_EXCLUDED_FIELDS = [
  "id",
  "acl",
  "creator",
  "editor",
  "created",
  "updated",
];

function CollapseView(
  id,
  object,
  collapsableFields,
  fields,
  actions,
  onEdit,
  showActions,
  fieldImage,
) {
  const excluded = new Set(DEFAULT_EXCLUDED_FIELDS);
  const fieldsToUse =
    collapsableFields && Object.keys(collapsableFields).length > 0
      ? collapsableFields
      : fields;
  const allKeys = Object.keys(fieldsToUse);
  const onCollapseKeys = allKeys.filter(
    (field) => fieldsToUse[field]?._onCollapse === true,
  );
  const fieldKeysToShow =
    collapsableFields && Object.keys(collapsableFields).length > 0
      ? allKeys.filter((field) => !excluded.has(field))
      : onCollapseKeys.length > 0
        ? onCollapseKeys
        : allKeys.filter(
            (field) =>
              !excluded.has(field) && fieldsToUse[field]?._onCollapse !== true,
          );

  return (
    <div className="border rounded overflow-hidden">
      <div className="d-flex p-2">
        {fieldImage &&
          object?.[fieldImage] != null &&
          object[fieldImage] !== "" && (
            <div
              className="mb-3 border"
              style={{
                width: "100px",
                height: "100px",
              }}
            >
              <img
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
                src={object[fieldImage]}
              />
            </div>
          )}
        <ul className="list-unstyled ms-1">
          {fieldKeysToShow.map((field) => {
            const options = fieldsToUse[field];
            if (options._type === "Image" && !object[field]) {
              return null;
            }
            const output = (
              <OutputFactory field={field} object={object} {...options} />
            );

            if (!output) return null;
            return (
              <li
                key={field}
                className="d-flex gap-2 text-center align-items-center"
              >
                <span className="ms-2 fw-bold">
                  {camelToTitleCase(options.label || field)}:{" "}
                </span>
                <span className="fs-sm text-nowrap align-self-center">
                  {output}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      {showActions && (
        <div className="bg-light p-2 border-top">
          {actions.length > 0 ? (
            <div className="d-flex gap-2">
              {actions.map((action, index) => {
                const visible =
                  typeof action.show !== "function" || action.show(object);
                return (
                  visible && (
                    <button
                      key={index}
                      className={
                        action.className
                          ? action.className
                          : "btn btn-primary btn-sm ms-2"
                      }
                      onClick={() => action.onClick(object)}
                    >
                      <i
                        className={`${typeof action.icon === "function" ? action.icon(object) : action.icon} me-2`}
                      ></i>
                      {typeof action.label === "function"
                        ? action.label(object)
                        : action.label}
                    </button>
                  )
                );
              })}
            </div>
          ) : (
            <button
              className="btn text-white btn-sm btn-primary"
              onClick={() => onEdit(object)}
            >
              <i className="bi bi-pencil me-2"></i>
              Edit
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default CollapseView;
